import { useRef, useEffect } from 'react'

export const useCoupledScroll = () => {
    const PatientRef = useRef(null)
    const RequestRef = useRef(null)
    const isScrollingRef = useRef(false)

    useEffect(() => {
        const patientElement = PatientRef.current
        const requestElement = RequestRef.current

        if (!patientElement || !requestElement) return

        const handlePatientScroll = () => {
            if (isScrollingRef.current) return
            isScrollingRef.current = true
            
            const scrollPercentage = patientElement.scrollTop / (patientElement.scrollHeight - patientElement.clientHeight)
            const targetScrollTop = scrollPercentage * (requestElement.scrollHeight - requestElement.clientHeight)
            
            requestElement.scrollTop = targetScrollTop
            
            setTimeout(() => {
                isScrollingRef.current = false
            }, 10)
        }

        const handleRequestScroll = () => {
            if (isScrollingRef.current) return
            isScrollingRef.current = true
            
            const scrollPercentage = requestElement.scrollTop / (requestElement.scrollHeight - requestElement.clientHeight)
            const targetScrollTop = scrollPercentage * (patientElement.scrollHeight - patientElement.clientHeight)
            
            patientElement.scrollTop = targetScrollTop
            
            setTimeout(() => {
                isScrollingRef.current = false
            }, 10)
        }

        patientElement.addEventListener('scroll', handlePatientScroll)
        requestElement.addEventListener('scroll', handleRequestScroll)

        return () => {
            patientElement.removeEventListener('scroll', handlePatientScroll)
            requestElement.removeEventListener('scroll', handleRequestScroll)
        }
    }, [])

    return {
        PatientRef,
        RequestRef,
    }
}
